import m from "../../geodata/es2015/syriaHigh";
window.am4geodata_syriaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/syriaHigh.js
// module id = null
// module chunks = 